import { render, staticRenderFns } from "./ProductGroupUpdate.vue?vue&type=template&id=6a44400a&scoped=true&"
import script from "./ProductGroupUpdate.vue?vue&type=script&lang=js&"
export * from "./ProductGroupUpdate.vue?vue&type=script&lang=js&"
import style0 from "./ProductGroupUpdate.vue?vue&type=style&index=0&id=6a44400a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a44400a",
  null
  
)

export default component.exports